import React, { Component } from 'react'

// ui
import Pagination from '../../components/uielements/pagination'

// redux
import { connect } from 'react-redux'
import userActions from '../../redux/user/actions'

class Paginate extends Component {
    onShowSizeChange = (current, pageSize) => {
        this.props.changePageSize(pageSize)
    }

    onChange(pageNumber) {
        this.props.changeCurrentPage(pageNumber)
    }

    render() {
        const { total, pageSize, current } = this.props

        return (
            <div className="PaginateContainer">
                <Pagination
                    showSizeChanger
                    onShowSizeChange={(current, pageSize) => this.onShowSizeChange(current, pageSize)}
                    onChange={(pageNumber) => this.onChange(pageNumber)}
                    current={current}
                    pageSizeOptions={['5', '6', '8', '10', '15']}
                    total={total}
                    showQuickJumper
                    pageSize={pageSize}
                />
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        total: state.user.total,
        pageSize: state.user.numberOfPage,
        current: state.user.currentPage,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        changePageSize: pageSize => {
            dispatch(userActions.action.changeNumberOfPage(pageSize))
        },
        changeCurrentPage: pageNumber => {
            dispatch(userActions.action.changeCurrentPage(pageNumber))
        },
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Paginate)
